import React from 'react';
import { Subject } from 'rxjs';
import { SubManager } from '../../classes/SubManager';
import { AsperaError } from '../../classes/AsperaError';
import { AsperaForm } from '../AsperaForm';
import { AsperaWrapper } from '../AsperaWrapper';
/**
 * React component
 *
 * View for rendering form in a modal with form rules for modal submit
 */
export class ModalFormRender extends React.Component {
    constructor() {
        super(...arguments);
        this.model = {};
        this.validFormSubject = new Subject();
        this.subManager = new SubManager();
    }
    componentDidMount() {
        const { disableSubject } = this.props;
        this.subManager.setSubscription(this.validFormSubject.subscribe({
            next: valid => {
                if (disableSubject) {
                    disableSubject.next(!valid);
                }
            },
            error: error => {
                new AsperaError('ModalFormRender: unable to subscribe for valid form', error);
            },
        }));
    }
    componentWillUnmount() {
        const { modalClose } = this.props;
        this.subManager.unsubscribeAll();
        modalClose({});
    }
    render() {
        const { formData, className } = this.props;
        return (React.createElement(AsperaWrapper, { className: `modal-text-input ${className}`, disableWrapping: true },
            React.createElement(AsperaForm, { formDetails: formData, validFormSubject: this.validFormSubject })));
    }
}
